import type { SuccessResponseBody } from '#core/types/api'
import { buildApiQuery } from '#core/composables/useApiQuery'
import { useQuery } from '@pinia/colada'

export type ProjectLogs = SuccessResponseBody<'/projects/{projectId}/logs'>
export type ProjectLog = ProjectLogs['items'][number]
export type ProjectLogCategories = SuccessResponseBody<'/projects/{projectId}/business-intelligence/logs/categories'>

export function useQueryProjectLogs() {
  const auth = useAuth()

  // Note: need to destructure here so that the data ref is reactive
  const {
    data,
    refresh,
    isLoading,
    isPending,
  } = useQuery({
    ...buildApiQuery('/projects/{projectId}/logs', {
      method: 'get',
      params: () => ({
        path: {
          projectId: auth.project?.id ?? '',
        },
        query: {
          tool: 'business-intelligence' as const,
        },
      }),
      options: {
        stableData: true,
        toast: true,
      },
    }),
    enabled: () => Boolean(auth.project?.id && auth.project.tokenListed),
  })

  return {
    data,
    refresh,
    isLoading,
    isPending,
  }
}
